import React from "react";
import AuthenticationApi from '../api/authenticationApi'
import LocalStorageHelper from '../common/localStorageHelper'

export default class User extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            collapse: true
        };
    }

    toggleCollapse() {
        this.setState({ collapse: !this.state.collapse });
    }

    logOut() {
        LocalStorageHelper.removeUser()
        this.props.onLoginChange(false, null)
        AuthenticationApi.logOut(this.props.user.token)
        window.location.reload(true)
    }

    render() {
        return (
            this.props.user ?
                <div style={{zIndex: '-1'}}>
                    <div className="center">
                        <a onClick={this.toggleCollapse.bind(this)}>
                            <img src={this.props.user.avatarUrl} width="40" />
                        </a>
                    </div>
                    <br className="clear" />
                    <div>
                            <div className="center">
                                <button className="logout-button" onClick={this.logOut.bind(this)}>
                                    Log Out
                                </button>
                            </div>
                            <br className="clear" />
                        </div>
                    {/* {this.state.collapse ? null :
                        <div>
                            <div className="center">
                                <button className="logout-button" onClick={this.logOut.bind(this)}>
                                    Log Out
                                </button>
                            </div>
                            <br className="clear" />
                        </div>
                    } */}
                </div>
                : null
        )
    }
}